import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CheckAuthorizationService } from './check-authorization.service';

/** A router wrapper, adding extra functions. */
@Injectable({
    providedIn: 'root'
  })
export class RouterExtService {

    private previousUrl: any = undefined;
    private currentUrl: any = undefined;

    constructor(public router: Router, private checkAuthorizationService: CheckAuthorizationService) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
        });
    }

    public getPreviousUrl() {
        return this.previousUrl !== '/' ? this.previousUrl : '/pages/maptiler';
    }

    async redirectUser() {
        try {
            if (this.router.url.indexOf('/auth/login') > -1) {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
            }
            const moduleName = 'TrackingScreen';
            const requiredPolicy = 'Read';
            const requiredPolicyForFleet = {
                moduleName: moduleName,
                policy: requiredPolicy,
            };
            const fleetViewPermission = await this.checkAuthorizationService.checkAuthorization(requiredPolicyForFleet);
            if (fleetViewPermission) {
                this.router.navigate(['/pages/maptiler']);
                return;
            } else {
                const requiredPolicyForVoyages = {
                    moduleName: 'Passages',
                    policy: 'Read',
                };
                const voyagesPermission =
                    await this.checkAuthorizationService.checkAuthorization(requiredPolicyForVoyages);
                if (voyagesPermission) {
                    this.router.navigate(['/pages/passages/voyages']);
                    return false;
                } else {
                    this.router.navigate(['/pages/user-profile']);
                    return false;
                }
            }
        } catch (err) {
        }
        return false;
    }
}
